import styled from "styled-components";
import { media } from "./breakpoints";

export const StyledFooter = styled.div`
  color: var(--gray);
  font-size: var(--fs-xs);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.2rem;
  padding: 3rem;

  a {
    color: var(--gray);
    text-decoration: none;
    &:hover {
      color: var(--purple);
    }
  }

  ${media.xxs`
  text-align: center;
  `}
`;
